// extracted by mini-css-extract-plugin
export default {"sideMenu":"SideMenu_sideMenu__d-9q1","name":"SideMenu_name__eNe9-","menu":"SideMenu_menu__hHlAE","menuItem":"SideMenu_menuItem__g3w0D","divider":"SideMenu_divider__HOLqk"};